import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import ModuleCQ9Funalo from "./promotion_modules/modules_cq9Funalo"

export default function CQ9Gaming() {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "CQ9 Funalo": ModuleCQ9Funalo,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const data = promotionsData.find((promo) => promo.title === "CQ9 Funalo")
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const handleCQ9Funalo = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("CQ9 Funalo")
    }
  }

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <title>CQ9 Funalo</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>CQ9 Funalo</h1>
                <h2>
                  Bawat winning round, may puntos - araw araw FUNALO ngayong
                  Pasko!
                </h2>
                <div className="promotion-tnc-period">
                  <strong> Event Period: </strong>
                  <span> December 1 (12PM) - December 31 (12PM)</span>
                  <span>
                    {" "}
                    Winners will be announced and prizes credited at 3PM daily
                  </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                {isLoggedIn && data.title === "CQ9 Funalo" && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleCQ9Funalo}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <strong> Eligibility: </strong>
                <ol>
                  <li>All registered FGH members are eligible.</li>
                  <li>
                    Only gameplay on CQ9 slot games counts toward this promo.
                  </li>
                </ol>
                <strong> How to Join: </strong>
                <ol>
                  <li>
                    Simply play any CQ9 slot game between 12PM and 12PM the next
                    day.
                  </li>
                  <li>
                    The system will automatically record your{" "}
                    <strong className="highlight">
                      {" "}
                      payout per round and convert it into points{" "}
                    </strong>{" "}
                    for all the leaderboard.
                  </li>
                </ol>
                <strong> Scoring Formula </strong>
                <ol>
                  <li>
                    Your Score ={" "}
                    <strong className="highlight">
                      {" "}
                      Payout in one Round / 100.
                    </strong>
                  </li>
                  <li>
                    <strong className="highlight">
                      Only winning rounds are counted.
                    </strong>
                  </li>
                  <li>
                    Player's <strong className="highlight"> daily score</strong>{" "}
                    = sum of round scores in the promo period.
                  </li>
                </ol>
                <ul>
                  <li>
                    <strong className="highlight">Example 1</strong> Player A
                  </li>
                  <li>Round 1 Win: ₱450 → Score = 4.5</li>
                  <li>Round 2 Win: ₱900 → Score = 9</li>
                  <li>
                    Daily Score = 4.5 + 9 ={" "}
                    <strong className="highlight"> 13.5 Points</strong>
                  </li>
                </ul>
                <ul>
                  <li>
                    <strong className="highlight">Example 2</strong> Player B
                  </li>
                  <li>Round 1 Win: ₱25,000 → Score = 250</li>
                  <li>Round 2 Win: ₱10,000 → Score = 100</li>
                  <li>
                    Daily Score = 250 + 100 ={" "}
                    <strong className="highlight"> 350 Points</strong>
                  </li>
                </ul>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0" }}
                  >
                    <thead>
                      <th colSpan={2}>🏆 Daily Prizes</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> Rank </td>
                        <td> Reward (Free Credits) </td>
                      </tr>
                      <tr>
                        <td> 1st </td>
                        <td> 1000 </td>
                      </tr>
                      <tr>
                        <td> 2nd </td>
                        <td> 800 </td>
                      </tr>
                      <tr>
                        <td> 3rd </td>
                        <td> 500 </td>
                      </tr>
                      <tr>
                        <td> 4th-10th </td>
                        <td> 300 </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <strong> Terms and Conditions </strong>
                <ol>
                  <li>
                    Only{" "}
                    <strong className="highlight">
                      {" "}
                      winning rounds are counted.
                    </strong>
                  </li>
                  <li>
                    Only game activity from{" "}
                    <strong className="highlight">
                      CQ9 Slots with 500 turnover and above
                    </strong>{" "}
                    (total bets daily) are included in the ranking.
                  </li>
                  <li>
                    <strong className="highlight">
                      Score = sum of all round scores (payout ÷ 100).
                    </strong>
                  </li>
                  <li>
                    <strong className="highlight">
                      Prizes credited daily at 3PM
                    </strong>{" "}
                    with no rollover requirement; leaderboard resets daily at
                    12PM.
                  </li>
                  <li>
                    Players with irregular betting or multiple accounts will be
                    disqualified.
                  </li>
                  <li>
                    FGH reserves the right to modify or cancel the event
                    anytime.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
